module.exports = __webpack_public_path__ + "assets/images/heart_disease_y.c62a7d6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/heart_disease_y.png
// module id = 731
// module chunks = 1